import {
    setPostcodeAction,
    setRegistrationAction,
    setTyreAction,
    setStateAction,
    setVehicleNotProvidedCommentAction,
} from '../../_flux/actions/rego_lookup_actions';
import { Filters } from '../../_flux/constants/filter/filters';
import CheckoutConfiguratorAnalytics from '../../_modules/google_analytics/checkout_configurator';
import {checkNextEmptyValueAvailable} from '../rego_lookup/check_next_empty_value_available';

export function onValueChangeFactory() {
    return (newValue, filterToUpdate) => {
        switch (filterToUpdate) {
            case Filters.VEHICLE_STATE:
                setStateAction(newValue);
                CheckoutConfiguratorAnalytics.selectStateInRegoLookupAction(newValue);
                break;
            case Filters.POSTCODE:
                setPostcodeAction(newValue);
                break;
            case Filters.REGISTRATION:
                setRegistrationAction(newValue);
                CheckoutConfiguratorAnalytics.setRegistrationInRegoLookupAction(newValue);
                break;
            case Filters.VEHICLE_NOT_PROVIDED_COMMENT:
                setVehicleNotProvidedCommentAction(newValue);
                break;
            case Filters.VEHICLE_TYRES:
                setTyreAction(newValue);
        }

        checkNextEmptyValueAvailable(filterToUpdate);
    }
}
